import useFormattedDate from "hooks/use-formatted-date";
import StarsRating from "./stars-rating";
import { Event } from "types/event";
import { interpolate } from "utils/interpolate";
import { useDictionary } from "hooks/use-dictionary";
import { ComponentProps } from "react";
import classNames from "classnames";
import { normalizeExternalUrl } from "utils/normalize-external-url";
import TagBase from "./tag-base";
import dayjs from "dayjs";

interface EventCardProps extends ComponentProps<"div"> {
  event: Event;
}

const EventCard = ({ event, className, ...props }: EventCardProps) => {
  const eventStartDate = useFormattedDate(event.startDate);
  const eventEndDate = useFormattedDate(event.endDate);
  const dict = useDictionary();
  const isEnded = dayjs(event.endDate).isBefore(dayjs());
  return (
    <div className={classNames("space-border bg-white p-4 rounded break-words", className)} {...props}>
      <div className="flex"></div>
      <div className="text-lg line-clamp-4">{event.name}</div>
      <div className="text-sm text-theme-gray300">{event.organizerInstitution.name}</div>
      {event.website && <div className="text-sm text-theme-gray300 break-all">{normalizeExternalUrl(event.website)}</div>}
      <div className="text-lg line-clamp-4">
        {eventStartDate} - {eventEndDate}
      </div>
      <StarsRating reviews={event.program.reviewRating} />
      <div className="flex justify-between text-lg">
        <div>
          {interpolate(dict.organizerAdmin.events.priceValue, {
            value: `${event.price}`,
          })}
        </div>
        <div>
          {interpolate(dict.organizerAdmin.events.durationValue, {
            value: `${event.program.duration ?? event.program.durationSum}`,
          })}
        </div>
      </div>
      {(event.isRemote || isEnded) && (
        <div className="mt-2 flex flex-wrap gap-2">
          {event.isRemote && <TagBase className="bg-theme-gray200">{dict.organizerAdmin.events.remoteTraining}</TagBase>}
          {isEnded && <TagBase className="bg-theme-gray50 text-theme-gray300">{dict.common.expiredTag}</TagBase>}
        </div>
      )}
    </div>
  );
};

export default EventCard;
